import { InputProps } from '../Input';

export interface Props {
	suggestions: string[];
	onSelect: (suggestion: string) => unknown;
	inputProps?: Omit<InputProps, 'onChangeText' | 'value'>;
	addNewTextResolver?: (inputValue: string) => string;
}
